export default "__VITE_ASSET__D$083SMu__"